import React from "react";

import { Toast, ToastContainer } from "react-bootstrap";

const Alert = ({ hideAlert, alert }) => {
  return (
    <ToastContainer className="p-3" position="top-end" style={{ zIndex: 9999 }}>
      <Toast
        show={alert.show}
        onClose={hideAlert}
        bg={alert.variant}
        delay={8000}
        autohide
      >
        <Toast.Header>
          <strong className="me-auto">
            {alert.variant === "danger" ? "Erro" : "Alerta"}
          </strong>
        </Toast.Header>
        <Toast.Body className={"Dark text-white m-2"}>
          {Array.isArray(alert.message) ? (
            <ul>
              {alert.message.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          ) : (
            alert.message
          )}
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default Alert;
